import { trackEvent } from '@/lib/trackEvent';
import { getScrollDepthPercent } from '@/lib/reportScrolled';

let stopCurrent: (() => void) | undefined;

export const startReportPageVisibilityTracking = (): (() => void) => {
  if (typeof document === 'undefined') {
    return () => undefined;
  }

  if (stopCurrent) {
    return () => undefined;
  }

  let lastVisibleAt = document.hidden ? null : Date.now();
  let lastHidden = document.hidden;

  const handleVisibilityChange = () => {
    if (document.hidden === lastHidden) return;
    lastHidden = document.hidden;
    const scrollDepth = getScrollDepthPercent();

    if (document.hidden) {
      const activeTimeMs =
        lastVisibleAt != null ? Math.max(0, Date.now() - lastVisibleAt) : 0;
      lastVisibleAt = null;
      trackEvent('page_hidden', {
        scroll_depth: scrollDepth,
        active_time_ms: activeTimeMs,
      });
      return;
    }

    lastVisibleAt = Date.now();
    trackEvent('page_visible', {
      scroll_depth: scrollDepth,
    });
  };

  document.addEventListener('visibilitychange', handleVisibilityChange);

  stopCurrent = () => {
    document.removeEventListener('visibilitychange', handleVisibilityChange);
    stopCurrent = undefined;
  };

  return () => {
    stopCurrent?.();
  };
};
